{
  "profilePage": {
    "editProfile": "Edit profile",
    "createProfile": "Create profile",
    "changePassword": "Change password",
    "changeLanguage": "Change language",
    "changeInfo": "Edit",
    "personalInfo": "Personal info",
    "userAttributes": "User attributes",
    "userPreferences": "User preferences",
    "loadError": "Failed to load data",
    "loadErrorDescription": "Could not load profile data. The server may be temporarily unavailable. Please try again.",
    "avatar": {
      "uploading": "Uploading",
      "selectImage": "Select image",
      "mimeTypeError": "You can only upload JPG/PNG file!",
      "fileSizeError": "Image must smaller than 2MB!"
    }
  },
  "passwordDialog": {
    "title": "Password change",
    "oldPassword": "Current password",
    "newPassword": "New password",
    "rePassword": "Repeat new password"
  },
  "languageDialog": {
    "title": "Choose language"
  },
  "avatarDialog": {
    "title": "Profile photo"
  },
  "userDialog": {
    "title": "User"
  },
  "userList": {
    "title": "User registry"
  },
  "userTokens": {
    "modalTitle": "Token Management",
    "columns": {
      "name": "Name",
      "display_name": "System name",
      "description": "Description",
      "status": "Status",
      "last_used_at": "Last Used",
      "active": "Active",
      "inactive": "Inactive",
      "never": "Never",
      "deactivateTitle": "Are you sure you want to deactivate the token?"
    },
    "deactivate": "Deactivate",
    "createToken": "Create token",
    "createModal": {
      "title": "New Token for",
      "token": "Token",
      "label": "Name",
      "name": "System name",
      "description": "Description",
      "generate": "Generate",
      "alert": "Warning: Save this token in a safe place. We do not store it in plain text and will not show it to you again."
    }
  },
  "userItem": {
    "profile": "Profile",
    "surname": "Last name",
    "name": "First name",
    "ldap_id": "LDAP",
    "is_password_expired": "Password expired",
    "correct": "Yes",
    "incorrect": "No",
    "patronymic": "Middle name",
    "email": "E-mail",
    "login": "Login",
    "language": "Language",
    "password": "Password",
    "confirmPassword": "Repeat password",
    "status": "Status",
    "connected_idps": "IDP providers",
    "connected_ldaps": "LDAP catalogs",
    "api_token": "API token",
    "statuses": {
      "title": "Status",
      "active": "Active",
      "block": "Blocked",
      "none": "No password"
    },
    "sessions_max_count": "Max session count",
    "password_updated_at": "Password update date",
    "password_expired_at": "Password expiration date",
    "login_failed_count": "The number of unsuccessful login attempts",
    "login_failed_at": "Date of the last unsuccessful login attempt",
    "last_action_at": "Date of the last successful user session",
    "updated_at": "Date the user was updated in the database",
    "created_at": "Date the user was created in the database",
    "addAttributes": "Add attributes",
    "editProfile": "Edit profile",
    "createProfile": "Create profile",
    "writePassword": "Write password",
    "confirmDelete": "Are you sure you want to delete the user?",
    "confirmBlock": "Are you sure you want to block this user?"
  },
  "UserAvatar": {
    "newAvatar": "New photo uploaded",
    "deleteAvatar": "Photo deleted"
  },
  "sessionList": {
    "title": "Users sessions",
    "terminateSession": "Terminate user session"
  },
  "sessionItem": {
    "login": "login",
    "last_action_at": "Last action",
    "expired_at": "Session expired",
    "addr": "Address",
    "agent": "Client"
  }
}